/**
 * Created by avasilescu on 13-Aug-2018.
 */

import React, {Component} from 'react';
import IvrStepProgress from "./IvrStepProgress";

class IvrStep extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {data, stepName, stepNumber} = this.props, {ivrStep} = data;

        return (
            <div className="ivr-transfer-status-box ivr-transfer-progress-msg ivr-transfer-ccn-msg">
                <div className="ivr-transfer-status-step-name">{stepName}</div>
                <div className="ivr-transfer-status-step-icon">
                    <IvrStepProgress data={data}
                                     progressCondition={ivrStep === stepNumber}
                                     completionCondition={ivrStep > stepNumber}/>
                </div>
                <div className="ivr-transfer-arrow"></div>
            </div>);
    }
}

export default IvrStep;